import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import theme from 'src/style/mui-theme'
import PropTypes from 'prop-types'

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
const MuiThemeProvider = ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>

MuiThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MuiThemeProvider
